<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-button v-if="!lo" size="mini" type="primary" class="float-right borcmodalbuton" @click="Borclandir">
      Borçlandırmayı Onayla
    </el-button>
    <div class="clearfix"></div>
    <hr>

    <el-row :gutter="24">
      <!--el-col :span="4">
        <mWidget
          :data="{isim: 'Borçlanma Tarihi', sayi: Bilgi.tTarihi, icon: 'el-icon-date', renk: 'ins1 m-widget-mini'}"></mWidget>
      </el-col-->
      <el-col :span="4">
        <mWidget
          :data="{isim: 'Son Ödeme Tarihi', sayi: Bilgi.sTarihi, icon: 'el-icon-date', renk: 'ins2 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="4">
        <mWidget
          :data="{isim: 'Okuma Tarihi', sayi: Bilgi.oTarihi, icon: 'el-icon-date', renk: 'ins3 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="4">
        <mWidget
          :data="{isim: 'Kategori', sayi: Bilgi.Kategori, icon: 'el-icon-s-claim', renk: 'ins4 m-widget-mini'}"></mWidget>
      </el-col>

      <el-col :span="4">
        <mWidget
          :data="{isim: 'Okuma Türü', sayi: Bilgi.ManuelSayac==1?'Endeks':'Manuel', icon: 'el-icon-picture-outline-round', renk: 'ins5 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="4">
        <mWidget
          :data="{isim: Bilgi.ManuelSayac==1?'Birim Fiyatı':'Fatura Tutarı', sayi: Bilgi.Tutar+' TL', icon: 'el-icon-wallet', renk: 'ins6 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="4" v-if="!Bilgi.ManuelSayac==1">
        <mWidget
          :data="{isim: 'Ortak Oran', sayi: '%'+Bilgi.SayacOrtak, icon: 'el-icon-pie-chart', renk: 'ins7 m-widget-mini'}"></mWidget>
      </el-col>
    </el-row>
    <table class="mt-4 table table-xs table-hover ">
      <thead>
      <tr>
        <th width="200">Borçlu Adı Soyadı</th>
        <th width="100">Mesken Bilgi</th>
        <th width="40">M2</th>
        <th width="100">İlk Endeks</th>
        <th width="100">Son Endeks</th>
        <th width="100" class="text-center">Fark Endeks</th>
        <th width="100" v-if="data[0].ManuelSayac!=1" class="text-center">Ortak Alan Bedeli</th>
        <th width="100" class="text-center">Tutar</th>
        <th width="300">Açıklama</th>

      </tr>
      </thead>
      <tbody v-for="Onay in data">
      <tr :class="Onay.TableClass">
        <td>{{Onay.Mesken.Oturan.AdSoyad}}</td>
        <td>{{Onay.Mesken.DaireBilgi}}</td>
        <td>{{Onay.Mesken.m2}}</td>
        <td v-if="!Onay.Muaf"><input type="number" @change="SayacHesap" v-model="Onay.Mesken.Borclar[0].IlkEndeks"
                                     class="form-control">
        </td>
        <td v-if="!Onay.Muaf"><input type="number" @change="SayacHesap" v-model="Onay.Mesken.Borclar[0].SonEndeks"
                                     class="form-control">
        </td>
        <td v-if="!Onay.Muaf" class="text-center">{{Onay.Mesken.Borclar[0].FarkEndeks}}</td>
        <td class="text-center" v-if="data[0].ManuelSayac!=1 && !Onay.Muaf">{{Onay.Mesken.Borclar[0].OrtakTutar}}</td>
        <td v-if="!Onay.Muaf" class="text-center">{{Onay.Mesken.Borclar[0].Tutar}}</td>
        <td v-if="!Onay.Muaf">
          <input v-model="Onay.Mesken.Borclar[0].Aciklama" class="form-control">
          <div v-if="Onay.Mesken.Borclar[0].Sms">
            <hr class="mb-0">
            <label>Sms İçerik</label>
            <el-input v-model="Onay.Mesken.Borclar[0].Sms" resize="none" type="textarea"></el-input>
            <small>Fark Endeks [Fark] , Borç Tutarı [Tutar] değişkenleri ile düzenlenecektir.</small>
          </div>
        </td>
        <td v-if="Onay.Muaf" colspan="6"></td>
      </tr>
      </tbody>
      <thead>
      <tr>
        <th colspan="3" class="text-right">ALT TOPLAM</th>
        <th class="text-center">{{ToplamIlkEndeks}}</th>
        <th class="text-center">{{ToplamSonEndeks}}</th>
        <th class="text-center">{{ToplamFarkEndeks}}</th>
        <th class="text-center" v-if="data[0].ManuelSayac!=1">{{ToplamOrtakAlan}}</th>
        <th class="text-center">{{ToplamTutar}}</th>
        <th></th>
      </tr>
      </thead>
    </table>

  </div>
</template>

<script>
  import MWidget from "../../Genel/mWidget";
  import Yukleniyor from "../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, MWidget},
    props: ['data', 'Bilgi'],
    data() {
      return {
        Hesaplama: false,
        ToplamIlkEndeks: 0,
        ToplamSonEndeks: 0,
        ToplamFarkEndeks: 0,
        ToplamOrtakAlan: 0,
        ToplamTutar: 0,
        lo: false
      }
    },
    methods: {
      SayacHesap() {
        this.ToplamIlkEndeks = 0;
        this.ToplamSonEndeks = 0;
        this.ToplamFarkEndeks = 0;
        this.ToplamOrtakAlan = 0;
        this.ToplamTutar = 0;
        this.data.forEach((data, index) => {
          if (data.Mesken.Borclar) {
            data.Mesken.Borclar[0].FarkEndeks = Number(data.Mesken.Borclar[0].SonEndeks - data.Mesken.Borclar[0].IlkEndeks);
            this.ToplamIlkEndeks += Number(data.Mesken.Borclar[0].IlkEndeks);
            this.ToplamSonEndeks += Number(data.Mesken.Borclar[0].SonEndeks);
            this.ToplamFarkEndeks += data.Mesken.Borclar[0].FarkEndeks;
            this.ToplamOrtakAlan += Number(data.Mesken.Borclar[0].OrtakTutar);
          }
        });
        this.data.forEach((data, index) => {
          if (data.Mesken.Borclar) {
            if (data.ManuelSayac) {
              // ENDEKS SAYAÇ OLAYI
              data.Mesken.Borclar[0].Tutar = Number(data.Mesken.Borclar[0].FarkEndeks * data.SayacTutar);
            } else {
              // FATURA SAYAÇ OLAYI
              data.Mesken.Borclar[0].Tutar = Number(data.Mesken.Borclar[0].FarkEndeks * (data.SayacTutar / this.ToplamFarkEndeks)).toFixed(2);
            }
            this.ToplamTutar += Number(data.Mesken.Borclar[0].Tutar);
          }


        });
        this.ToplamIlkEndeks = this.ToplamIlkEndeks.toFixed(2);
        this.ToplamSonEndeks = this.ToplamSonEndeks.toFixed(2);
        this.ToplamFarkEndeks = this.ToplamFarkEndeks.toFixed(2);
        this.ToplamOrtakAlan = this.ToplamOrtakAlan.toFixed(2);
        this.ToplamTutar = this.ToplamTutar.toFixed(2);
      },
      Borclandir() {
        this.lo = true
        this.$store.dispatch("Post", {...this.data, path: 'muhasebe/tahakkuk/tahakkuk/sayac'})
          .then(response => {
            if (response.Durum == "OK") {
              this.lo = false
              this.$emit("Onay", true);
              this.$message.success(response.Mesaj);
            } else {
              this.lo = false
              this.$message.error(response.Mesaj);
            }
          })
      },
    },
    created() {
      this.SayacHesap()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/tahakkuk/sayac.vue